import { render, staticRenderFns } from "./libraryManagement.vue?vue&type=template&id=a308bbc2&scoped=true"
import script from "./libraryManagement.vue?vue&type=script&lang=js"
export * from "./libraryManagement.vue?vue&type=script&lang=js"
import style0 from "./libraryManagement.vue?vue&type=style&index=0&id=a308bbc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308bbc2",
  null
  
)

export default component.exports